var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAppCategoryDashboardDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.815,
    height: 55.003,
    viewBox: "0 0 54.815 55.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30723",
    "data-name": "Group 30723",
    transform: "translate(-495 -273.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24190",
    "data-name": "Path 24190",
    d: "M36.188,26.089a1.834,1.834,0,0,0-2.171-.314A11.88,11.88,0,0,1,28.283,27.2a12.3,12.3,0,0,1-11.754-8.539,1.834,1.834,0,0,0-1.746-1.271H2.986A1.834,1.834,0,0,0,1.18,19.534,27.488,27.488,0,0,0,44.3,37.19,1.834,1.834,0,0,0,44.52,34.4Z",
    transform: "translate(494.035 286.654)",
    fill: "#827ca0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24191",
    "data-name": "Path 24191",
    d: "M33.637,7.616a1.834,1.834,0,0,0-1.34-.757,1.8,1.8,0,0,0-1.445.534L22.54,15.724a1.834,1.834,0,0,0-.314,2.171,11.88,11.88,0,0,1,1.423,5.732,12.133,12.133,0,0,1-1.834,6.443,1.834,1.834,0,0,0,.259,2.268l8.251,8.251a1.834,1.834,0,0,0,1.3.537h.117a1.834,1.834,0,0,0,1.335-.711,27.473,27.473,0,0,0,.55-32.8Z",
    transform: "translate(511.027 277.869)",
    fill: "#827ca0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24192",
    "data-name": "Path 24192",
    d: "M2.885,27.218H14.514a1.834,1.834,0,0,0,1.79-1.432,12.285,12.285,0,0,1,12.065-9.643,12.146,12.146,0,0,1,6.443,1.834,1.834,1.834,0,0,0,2.268-.257l8.251-8.251a1.834,1.834,0,0,0-.183-2.75A27.5,27.5,0,0,0,1.064,25.173a1.834,1.834,0,0,0,1.821,2.054Z",
    transform: "translate(493.949 272.994)",
    fill: "#827ca0",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppCategoryDashboardDark);
export default __webpack_public_path__ + "static/media/icon-AppCategory-dashboardDark.f558092d1f8608b985fa59646562125e.svg";
export { ForwardRef as ReactComponent };